import React, { useState } from 'react'
import { useNotificationService, useUserService } from '@abroad/components'
import { Col, Container, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { ShimmerThumbnail } from 'react-shimmer-effects'
import { openLinkInTab } from '../../utils/openLinkInTab'
import SupportModal from './SupportModal'
import { gtmViewExperienceEnrollmentResponsesAction } from './gtmQuestUploadFunctions'
import { gtmStartExperienceEnrollmentAction } from './gtmQuestUploadFunctions'
import { MediaBanner } from '../common'

const EnrollmentProcess = ({ questId, questSteps, isLoading }) => {
  const [showModal, setShowModal] = useState(false)
  const history = useHistory()
  const Notification = useNotificationService()
  const { user } = useUserService()

  const questCustomFormId = questSteps?.questCustomFormId
  const onboardingCompleted = questSteps?.onboardingCompleted || false

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleEnrollmentFormNavigation = () => {
    if (!questCustomFormId) {
      Notification.showNotification(
        'The form you are trying to open is unavailable.',
      )
      return
    }

    if (onboardingCompleted) {
      gtmViewExperienceEnrollmentResponsesAction(
        questId,
        questCustomFormId,
        user?._id,
      )
    } else {
      gtmStartExperienceEnrollmentAction(questId, questCustomFormId, user?._id)
    }

    openLinkInTab(
      onboardingCompleted
        ? `/your-experiences/${questId}/typeform/${questCustomFormId}/answer`
        : `/your-experiences/${questId}/typeform/${questCustomFormId}`,
      '_self',
    )
  }

  const handlePaymentNavigation = () => {
    history.push(`/your-experiences/${questId}/payments`)
  }

  const renderActionCard = (actionLabel, onClick) => (
    <Container fluid className='px-0'>
      <Row
        className='mb-lg-0 mb-4 enrollment-begin-card enrollment-process-banner begin-page mx-0 cursor-pointer'
        onClick={onClick}>
        <Col className='col-6 px-0 enrollment-begin-image'>
          <MediaBanner imageFilename='enrollment_process.jpg' />
        </Col>
        <Col className='col-6 bg-abroad-blue d-flex justify-content-center align-items-center enrollment-begin-action px-0'>
          <div className='d-flex begin-journey-section w-100 justify-content-center align-items-center'>
            <div className='text-white s9 mr-12px begin-text text-uppercase'>
              {actionLabel}
            </div>
            <span className='icon icon-right-arrow text-white' />
          </div>
        </Col>
      </Row>
    </Container>
  )

  return (
    <div>
      {!isLoading && (
        <div className='d-flex justify-content-between align-items-center mb-4'>
          <h3 className='mb-0 s3'>Enrollment Process</h3>
          <div className='d-flex align-items-center'>
            <div
              className='d-flex align-items-center text-saffron-700 cursor-pointer'
              onClick={handleOpenModal}>
              <span className='s7 ms-1'>Support</span>
            </div>
          </div>
        </div>
      )}

      {isLoading || !questId ? (
        <ShimmerThumbnail
          className='border-radius-10 mb-0'
          height={218}
          rounded
        />
      ) : !onboardingCompleted ? (
        renderActionCard('Begin', handleEnrollmentFormNavigation)
      ) : (
        renderActionCard('Make Payment', handlePaymentNavigation)
      )}

      <SupportModal showModal={showModal} handleClose={handleCloseModal} />
    </div>
  )
}

export default EnrollmentProcess
